var render = function render(){
  var _vm$orderDetail$order, _vm$orderDetail$order2, _vm$orderDetail$order3, _vm$orderDetail, _vm$orderDetail$order4, _vm$orderDetail$order5, _vm$orderDetail$order6, _vm$orderDetail2, _vm$orderDetail2$orde, _vm$orderDetail2$orde2, _vm$orderDetail3, _vm$orderDetail3$orde, _vm$orderDetail3$orde2, _vm$orderDetail4, _vm$orderDetail4$orde, _vm$orderDetail4$orde2, _vm$orderDetail5, _vm$orderDetail5$orde, _vm$orderDetail5$orde2, _vm$orderDetail6, _vm$orderDetail6$orde, _vm$orderDetail6$orde2, _vm$orderDetail7, _vm$orderDetail7$orde, _vm$orderDetail7$orde2, _vm$orderDetail8, _vm$orderDetail8$orde, _vm$orderDetail8$orde2, _vm$orderDetail9, _vm$orderDetail9$orde, _vm$orderDetail9$orde2, _vm$orderDetail10, _vm$orderDetail10$ord, _vm$orderDetail11, _vm$orderDetail11$pay, _vm$orderDetail12, _vm$orderDetail12$pay, _vm$orderDetail13, _vm$orderDetail13$pay, _vm$orderDetail14, _vm$orderDetail14$pay, _vm$orderDetail15;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order text-neutral-500"
  }, [_c('div', {
    staticClass: "bg-white mb-40"
  }, [_c('div', {
    staticClass: "flex gap-3 justify-between p-6 shadow-border-b"
  }, [_c('div', {
    staticClass: "flex gap-3"
  }, [_c('span', {
    staticClass: "flex justify-center items-center px-2 py-1 text-xs rounded-md",
    style: 'backgroundColor: ' + _vm.orderDetail.status_color + '; color: white;'
  }, [_vm._v(_vm._s(_vm.orderDetail.status_display))]), _c('div', [_c('span', {
    staticClass: "text-neutral-500 text-xs block mb-1"
  }, [_vm._v(_vm._s(_vm.orderDetail.created_time_display) + " / " + _vm._s(_vm.orderDetail.order_id))]), _c('p', {
    staticClass: "text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
  }, [_c('span', [_c('strong', [_vm._v("AWB Linknau")]), _vm._v(": " + _vm._s((_vm$orderDetail$order = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order === void 0 ? void 0 : _vm$orderDetail$order.awb))]), (_vm$orderDetail$order2 = _vm.orderDetail.order_delivery) !== null && _vm$orderDetail$order2 !== void 0 && _vm$orderDetail$order2.external_awb ? [_c('span', {
    staticClass: "mdmax:hidden"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("AWB Mitra")]), _vm._v(": " + _vm._s((_vm$orderDetail$order3 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order3 === void 0 ? void 0 : _vm$orderDetail$order3.external_awb))])] : _vm._e()], 2)])]), _vm.orderDetail.next_status ? _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Update Status"
    },
    on: {
      "action": function ($event) {
        return _vm.updateStatus();
      }
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Berat dan Jenis Paket")]), _vm._l((_vm$orderDetail = _vm.orderDetail) === null || _vm$orderDetail === void 0 ? void 0 : (_vm$orderDetail$order4 = _vm$orderDetail.order_delivery) === null || _vm$orderDetail$order4 === void 0 ? void 0 : _vm$orderDetail$order4.packages, function (packageItem, index) {
    return _c('div', {
      key: 'package-' + index,
      staticClass: "flex justify-start gap-6 mb-4 border rounded-md px-3 py-2 bg-neutral-200 last:mb-0"
    }, [_c('div', {
      staticClass: "w-2/5"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Berat Barang")]), _c('p', [_vm._v(_vm._s(packageItem.weight) + "kg")])]), _c('div', {
      staticClass: "w-3/5"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Jenis Paket")]), _c('p', [_vm._v(_vm._s(packageItem.category))])])]);
  })], 2), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Layanan")]), _c('div', {
    staticClass: "flex items-center"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Layanan")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail$order5 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order5 === void 0 ? void 0 : _vm$orderDetail$order5.service_package_name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Tipe Layanan")]), _c('p', [_vm._v(_vm._s(_vm.getServiceType((_vm$orderDetail$order6 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order6 === void 0 ? void 0 : _vm$orderDetail$order6.service_type) || '-'))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Pengiriman")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail2 = _vm.orderDetail) === null || _vm$orderDetail2 === void 0 ? void 0 : (_vm$orderDetail2$orde = _vm$orderDetail2.order_delivery) === null || _vm$orderDetail2$orde === void 0 ? void 0 : (_vm$orderDetail2$orde2 = _vm$orderDetail2$orde.sender) === null || _vm$orderDetail2$orde2 === void 0 ? void 0 : _vm$orderDetail2$orde2.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail3 = _vm.orderDetail) === null || _vm$orderDetail3 === void 0 ? void 0 : (_vm$orderDetail3$orde = _vm$orderDetail3.order_delivery) === null || _vm$orderDetail3$orde === void 0 ? void 0 : (_vm$orderDetail3$orde2 = _vm$orderDetail3$orde.sender) === null || _vm$orderDetail3$orde2 === void 0 ? void 0 : _vm$orderDetail3$orde2.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail4 = _vm.orderDetail) === null || _vm$orderDetail4 === void 0 ? void 0 : (_vm$orderDetail4$orde = _vm$orderDetail4.order_delivery) === null || _vm$orderDetail4$orde === void 0 ? void 0 : (_vm$orderDetail4$orde2 = _vm$orderDetail4$orde.sender) === null || _vm$orderDetail4$orde2 === void 0 ? void 0 : _vm$orderDetail4$orde2.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail5 = _vm.orderDetail) === null || _vm$orderDetail5 === void 0 ? void 0 : (_vm$orderDetail5$orde = _vm$orderDetail5.order_delivery) === null || _vm$orderDetail5$orde === void 0 ? void 0 : (_vm$orderDetail5$orde2 = _vm$orderDetail5$orde.sender) === null || _vm$orderDetail5$orde2 === void 0 ? void 0 : _vm$orderDetail5$orde2.detail_address) || '-'))])])]), _c('div', {
    staticClass: "p-6 mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Penerima")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail6 = _vm.orderDetail) === null || _vm$orderDetail6 === void 0 ? void 0 : (_vm$orderDetail6$orde = _vm$orderDetail6.order_delivery) === null || _vm$orderDetail6$orde === void 0 ? void 0 : (_vm$orderDetail6$orde2 = _vm$orderDetail6$orde.receiver) === null || _vm$orderDetail6$orde2 === void 0 ? void 0 : _vm$orderDetail6$orde2.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail7 = _vm.orderDetail) === null || _vm$orderDetail7 === void 0 ? void 0 : (_vm$orderDetail7$orde = _vm$orderDetail7.order_delivery) === null || _vm$orderDetail7$orde === void 0 ? void 0 : (_vm$orderDetail7$orde2 = _vm$orderDetail7$orde.receiver) === null || _vm$orderDetail7$orde2 === void 0 ? void 0 : _vm$orderDetail7$orde2.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail8 = _vm.orderDetail) === null || _vm$orderDetail8 === void 0 ? void 0 : (_vm$orderDetail8$orde = _vm$orderDetail8.order_delivery) === null || _vm$orderDetail8$orde === void 0 ? void 0 : (_vm$orderDetail8$orde2 = _vm$orderDetail8$orde.receiver) === null || _vm$orderDetail8$orde2 === void 0 ? void 0 : _vm$orderDetail8$orde2.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail9 = _vm.orderDetail) === null || _vm$orderDetail9 === void 0 ? void 0 : (_vm$orderDetail9$orde = _vm$orderDetail9.order_delivery) === null || _vm$orderDetail9$orde === void 0 ? void 0 : (_vm$orderDetail9$orde2 = _vm$orderDetail9$orde.receiver) === null || _vm$orderDetail9$orde2 === void 0 ? void 0 : _vm$orderDetail9$orde2.detail_address) || '-'))])])])]), _c('div', {
    staticClass: "flex-1 shadow-border-l mdmax:shadow-none"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Foto Barang")]), _vm._l((_vm$orderDetail10 = _vm.orderDetail) === null || _vm$orderDetail10 === void 0 ? void 0 : (_vm$orderDetail10$ord = _vm$orderDetail10.order_delivery) === null || _vm$orderDetail10$ord === void 0 ? void 0 : _vm$orderDetail10$ord.packages, function (paket, index) {
    return _c('div', {
      key: 'paket-' + index,
      staticClass: "mb-4"
    }, [paket.photo_from_courier ? [_c('img', {
      attrs: {
        "src": paket.photo_from_courier
      }
    })] : _c('p', [_vm._v("- Foto tidak tersedia -")])], 2);
  })], 2), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Informasi Pembayaran")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Status")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail11 = _vm.orderDetail) === null || _vm$orderDetail11 === void 0 ? void 0 : (_vm$orderDetail11$pay = _vm$orderDetail11.payment_info) === null || _vm$orderDetail11$pay === void 0 ? void 0 : _vm$orderDetail11$pay.status) || '-'))])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Tipe Pembayaran")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail12 = _vm.orderDetail) === null || _vm$orderDetail12 === void 0 ? void 0 : (_vm$orderDetail12$pay = _vm$orderDetail12.payment_info) === null || _vm$orderDetail12$pay === void 0 ? void 0 : _vm$orderDetail12$pay.payment_method) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Bank")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail13 = _vm.orderDetail) === null || _vm$orderDetail13 === void 0 ? void 0 : (_vm$orderDetail13$pay = _vm$orderDetail13.payment_info) === null || _vm$orderDetail13$pay === void 0 ? void 0 : _vm$orderDetail13$pay.payment_provider) || '-'))])])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No Rekening")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail14 = _vm.orderDetail) === null || _vm$orderDetail14 === void 0 ? void 0 : (_vm$orderDetail14$pay = _vm$orderDetail14.payment_info) === null || _vm$orderDetail14$pay === void 0 ? void 0 : _vm$orderDetail14$pay.payment_account_display) || '-'))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Status Pengiriman")]), _vm._l((_vm$orderDetail15 = _vm.orderDetail) === null || _vm$orderDetail15 === void 0 ? void 0 : _vm$orderDetail15.tracking_infos, function (tracking, index) {
    return _c('div', {
      key: 'tracking' + index,
      staticClass: "flex gap-5"
    }, [_c('div', {
      staticClass: "line relative"
    }, [_c('span', {
      staticClass: "inline-block w-5 h-5 rounded-full border-4 relative z-1",
      class: index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'
    }), _c('span', {
      staticClass: "absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"
    })]), _c('div', {
      staticClass: "status mb-6"
    }, [_c('p', {
      staticClass: "text-sm mb-1"
    }, [_vm._v(_vm._s(tracking.time_display))]), _c('p', {
      staticClass: "text-neutral-700 mb-1"
    }, [_vm._v(_vm._s(tracking.main_info))]), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(tracking.additional_info))])])]);
  })], 2)])]), _vm.orderDetail.is_require_hubcek ? _c('div', {
    staticClass: "text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v("Jangan lupa periksa kembali barang yang telah diterima sebelum memindahkan status order, pastikan sesuai dengan ukuran yang telah ditetapkan. ")], 1) : _vm._e(), _vm.orderDetail.is_require_hubcek ? _c('div', {
    staticClass: "p-6 flex justify-end gap-4 items-center"
  }, [_vm.alreadyResponsed ? [_c('LinkButton', {
    attrs: {
      "buttonText": "Kembali",
      "url": "/order",
      "linkType": "internal"
    }
  })] : [_c('div', {
    staticClass: "w-44"
  }, [_c('CustomSelect', {
    attrs: {
      "options": _vm.rejectReasons,
      "default": _vm.selectedReason,
      "placeholder": "Pilih Aksi"
    },
    model: {
      value: _vm.selectedReason,
      callback: function ($$v) {
        _vm.selectedReason = $$v;
      },
      expression: "selectedReason"
    }
  })], 1), _c('div', {
    staticClass: "w-44"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Submit",
      "size": "big_full",
      "disabled": !_vm.selectedReason
    },
    on: {
      "action": function ($event) {
        return _vm.toggleConfirmModal('proceed');
      }
    }
  })], 1)]], 2) : _vm._e()]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleConfirmModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Perubahan Status")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v("Pastikan informasi alamat dan isi paket sesuai dengan ketentuan barang yang telah ditetapkan. perubahan proses tidak bisa di ubah")])])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.proceed();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleAddCostModal,
      "width": "660px",
      "id": "add-cost-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleAddCostModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6 text-neutral-700 text-left"
  }, [_vm._v("Kurang Bayar")]), _c('div', {
    staticClass: "flex items-center gap-6 text-left mb-6"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Panjang")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageLength,
      callback: function ($$v) {
        _vm.packageLength = $$v;
      },
      expression: "packageLength"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Lebar")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageWidth,
      callback: function ($$v) {
        _vm.packageWidth = $$v;
      },
      expression: "packageWidth"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tinggi")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageHeight,
      callback: function ($$v) {
        _vm.packageHeight = $$v;
      },
      expression: "packageHeight"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)])]), _c('div', {
    staticClass: "text-left w-1/3 mb-10"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Penambahan Harga")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number",
      "withIcon": ""
    },
    model: {
      value: _vm.packagePrice,
      callback: function ($$v) {
        _vm.packagePrice = $$v;
      },
      expression: "packagePrice"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("Rp")])], 1)]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tutup",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleAddCostModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Submit",
      "type": "primary",
      "disabled": _vm.invalidPackageInformation,
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.rejectAddCost();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleOtherModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleOtherModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "p-1"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6 text-neutral-700 text-left"
  }, [_vm._v("Lainnya")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "placeholder": "Silakan tulis alasannya",
      "borderEnabled": "",
      "error": _vm.otherReasonError
    },
    model: {
      value: _vm.otherReason,
      callback: function ($$v) {
        _vm.otherReason = $$v;
      },
      expression: "otherReason"
    }
  })], 1), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tutup",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleOtherModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Submit",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.rejectOther();
      }
    }
  })], 1)])])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }